exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-0db579d6] {\n  font-size: 18px;\n}\n", ""]);

// exports
